import bem from 'utils/bem';

export const block = bem('ai-captions-upsell-modal');
